import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
export function ObjectionsSection() {
  const faqs = [{
    q: '¿Es solo otro libro motivacional?',
    a: 'No. No encontrarás frases positivas vacías. Encontrarás honestidad radical y promesas bíblicas probadas para momentos de crisis real.'
  }, {
    q: 'No tengo tiempo para leer.',
    a: 'Solo necesitas 5 minutos al día. Menos que un café. Está diseñado para leerse en los momentos muertos de tu día o justo al despertar.'
  }, {
    q: '¿Funciona si mi fe está muy débil?',
    a: 'Fue diseñado exactamente para eso. No necesitas fe fuerte para empezar. Solo necesitas presentarte tal como estás.'
  }, {
    q: '¿Y si no soy muy practicante?',
    a: 'Es un punto de partida perfecto. No requiere conocimiento teológico avanzado, solo un corazón dispuesto y honestidad.'
  }];
  return <section className="py-20 px-6 bg-[var(--bg-surface)]" data-id="element-220">
      <div className="max-w-[680px] mx-auto" data-id="element-221">
        <h2 className="text-3xl font-serif text-center mb-12 text-[var(--text-heading)]" data-id="element-222">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-223">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[var(--bg-elevated)] rounded p-6 border border-transparent hover:border-[var(--accent)]/20 transition-colors" data-id="element-224">
              <h3 className="font-serif font-bold text-[var(--text-heading)] mb-2 text-lg" data-id="element-225">
                {faq.q}
              </h3>
              <p className="text-[var(--text-muted)] leading-relaxed text-sm" data-id="element-226">
                {faq.a}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}